import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { UPDATE_INVESTOR_INFO } from "./apiRoutes";

const mutateUpdateInvestorInfo = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${UPDATE_INVESTOR_INFO}/${id}`, data);
};

const useUpdatInvestorInfoMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateInvestorInfo,
    ...queryParams,
  });

export default useUpdatInvestorInfoMutation;
